import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { NetworkStatus } from '@cbridge-utils/network';

import { ExposureAction } from './exposure.action';
import { exposureInitialState } from './exposure.constant';

export const exposureReducer = reducerWithInitialState(exposureInitialState)
  // list
  .case(ExposureAction.loadSymbolList.started, (state) => ({
    ...state,
    symbols: {
      ...state.symbols,
      networkStatus: NetworkStatus.Started,
    },
  }))
  .case(ExposureAction.loadSymbolList.done, (state, { result }) => ({
    ...state,
    lastUpdated: +Date.now(),
    symbols: {
      ...state.symbols,
      data: result,
      networkStatus: NetworkStatus.Done,
    },
  }))
  .case(ExposureAction.loadSymbolList.failed, (state) => ({
    ...state,
    symbols: {
      ...state.symbols,
      networkStatus: NetworkStatus.Failed,
    },
  }))
  // details
  .case(ExposureAction.loadDetails.started, (state) => ({
    ...state,
    details: {
      ...state.details,
      networkStatus: NetworkStatus.Started,
    },
  }))
  .case(ExposureAction.loadDetails.done, (state, { result }) => ({
    ...state,
    details: {
      ...state.details,
      data: result,
      networkStatus: NetworkStatus.Done,
    },
  }))
  .case(ExposureAction.loadDetails.failed, (state) => ({
    ...state,
    details: {
      ...state.details,
      networkStatus: NetworkStatus.Failed,
    },
  }))
  // clean up
  .case(ExposureAction.destroy, () => ({
    ...exposureInitialState,
  }));
